import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import NewPost from './NewPost';
import Project from './Project';
import { BrowserRouter, Routes, Route } from "react-router";

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <BrowserRouter>
    <Routes>
      <Route path="/" element={<App />}>
        <Route path="projects/:projectId" element={<Project />} />
      </Route>
      <Route path="admin" element={<NewPost />} />
    </Routes>
  </BrowserRouter>
);
